/**
 * Agents the Account Settings tabs (Memory, Knowledge) can be scoped to — one list
 * so the two selectors on the page always offer the same agents.
 *
 * Static on purpose: the backends need an explicit agent_name, and there is no
 * per-user agent list to read from yet. Revisit once multi-agent runtime wiring
 * lands (see MULTI_AGENT_ENABLED in config.ts); then source this from a real
 * backend (agent registry / API).
 *
 * Campaign Copilot is left out: it is hidden from everyone (HIDDEN_AGENT_IDS in config.ts).
 */
export const SETTINGS_AGENTS: { id: string; label: string }[] = [
  { id: 'rocky', label: 'Rocky' },
  { id: 'marketing_agent', label: 'Marketing Agent' },
  { id: 'acquisition_agent', label: 'Acquisition Agent' },
  { id: 'data_ops_agent', label: 'Data Ops' },
];
